var __makeTemplateObject =
  (this && this.__makeTemplateObject) ||
  function (cooked, raw) {
    if (Object.defineProperty) {
      Object.defineProperty(cooked, 'raw', { value: raw })
    } else {
      cooked.raw = raw
    }
    return cooked
  }
var __assign =
  (this && this.__assign) ||
  function () {
    __assign =
      Object.assign ||
      function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i]
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p]
        }
        return t
      }
    return __assign.apply(this, arguments)
  }
import * as React from 'react'
import styled from 'styled-components'
var BodyWrapper = styled.div(
  templateObject_1 ||
    (templateObject_1 = __makeTemplateObject(
      ['\n  padding-left: ', ';\n  padding-right: ', ';\n  padding-bottom: ', ';\n'],
      ['\n  padding-left: ', ';\n  padding-right: ', ';\n  padding-bottom: ', ';\n']
    )),
  function (p) {
    return p.contentsLRPadding
  },
  function (p) {
    return p.contentsLRPadding
  },
  function (p) {
    return p.contentsBottomPadding
  }
)
var defaultODModalBodyProps = {
  contentsLRPadding: '37px',
  contentsBottomPadding: '44px',
}
export var ODModalBody = function (_a) {
  var _b = _a.style,
    style = _b === void 0 ? {} : _b,
    children = _a.children
  var p = defaultODModalBodyProps
  return React.createElement(BodyWrapper, __assign({}, p, { style: style }), children)
}
var templateObject_1
//# sourceMappingURL=ODModalBody.js.map
